import { render, staticRenderFns } from "./itmoCard.vue?vue&type=template&id=723489f0&"
import script from "./itmoCard.vue?vue&type=script&lang=js&"
export * from "./itmoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports